module.exports = __webpack_public_path__ + "static/media/account.0841391d.svg";